"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @reducer buildRouteMeta - this takes all the route data and makes a meta object from it
 */
var route_1 = require("../actions/route");
/**
 * Save enter route into history for debugging purpose
 *
 * @param state
 * @param action - should have route info from the action creator
 * @returns {*} - state.route is updated with { enter, exit, history, isFlow }
 */
function buildRouteMeta(state, action) {
    var enter = Object.assign({}, action.route.enter), exit = null, history = state.history || [], isFlow = !!action.route.isFlow || state.isFlow, enterUrl = enter.params && enter.params['0'];
    if (enterUrl) {
        // first add latest url to beginning of list
        history = [enterUrl].concat(state.history)
            // then keep the latest 10 entries only
            .slice(0, 10);
    }
    if (action.route.exit) {
        exit = Object.assign({}, action.route.exit);
    }
    return Object.assign({}, state, {
        enter: enter,
        exit: exit,
        history: history,
        isFlow: isFlow
    });
}
function routeReducer(state, action) {
    if (state === void 0) { state = route_1.DefaultRoute; }
    switch (true) {
        case action.type.includes(route_1.CHANGE_ROUTE):
        case action.type.includes(route_1.CLEAR_ROUTE):
            return buildRouteMeta(state, action);
        case action.type.includes(route_1.TRANSITION_FADE_OUT):
            return Object.assign({}, state, { transition: 'fade-out' });
        case action.type.includes(route_1.TRANSITION_FADE_IN):
            return Object.assign({}, state, { transition: 'fade-in' });
        default:
            return state;
    }
}
exports.default = routeReducer;
